(ns app.front.dashboard.welcome
  "A welcome page is shown instead of the dashboard for a new user.
  A new user is one who has no workspaces and has no assigned tasks"
  (:require [app.front.dashlets :as dashlets]
            [app.front.task :as task]
            [app.front.util :as futil]
            [app.front.view.create-application.create-v2 :as create-v2]
            [app.front.view.navigation :as navigation]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx
  ::start-create
  (fn [_ _]
    {:fx [[:dispatch [::create-v2/start-create]]
          [:dispatch-later {:ms 200 :dispatch [::navigation/scroll-to-bottom]}]]}))


(defn- create-application-button [tr class create-app?]
  [:div.flex.justify-center
   (cc/button (merge
                {:size       :field
                 :class-name (futil/cs "p-4 px-8 max-w-none rounded-sm" class)
                 :on-click   #(>evt [(if create-app?
                                       ::create-v2/close-create
                                       ::start-create)])}
                (when create-app?
                  {:icon i/remove}))
              (tr [(if create-app?
                     :close
                     :welcome/create-application)]))])


(defn- welcome-section [tr header-loc body-loc]
  [:<>
   [:h3.mb-6.font-semibold (tr [header-loc])]
   [:span.leading-normal (tr [body-loc])]])


(defn- text-blocks [tr create-app?]
  (let [user (<sub [:session/user])]
    [:div.lg:px-20.flex.justify-center
     [:div.px-10.flex.flex-col
      [:h2.mt-10.lg:mt-20.mb-8.font-semibold (tr [:welcome/greeting] [(user-model/full-name user)])]
      [welcome-section tr :welcome/first-section-header :welcome/first-section-body]
      (let [loading?   (<sub [::dashlets/dashlet-loading? task/default-task-dashlet-id])
            task-items (<sub [::task/sorted-task-items task/default-task-dashlet-id])]
        (cond
          loading? (cc/loading-spinner {:with-overlay false})
          (seq task-items) [:div.pt-4.pb-8
                            [task/dashlet-content (util/mmap {:id task/default-task-dashlet-id} task-items tr)]]
          :else [create-application-button tr "my-20" create-app?]))
      [welcome-section tr :welcome/second-section-header :welcome/second-section-body]]]))


(defn- step-card [tr index]
  [:div.m-2.p-2.sm:p-4.md:py-6.bg-ui-white.rounded.border-2.border-solid.border-ui-violet-50
   [cc/icon {:icon        i/file-check
             :width       "50px"
             :height      "50px"
             :class-name  "my-8 mx-auto block"
             :description ""
             :aria-hidden true}]
   [:h4.my-4.text-center (tr [:welcome/step-header] [index])]
   [:span.mb-12.block.text-center
    (tr [(keyword "welcome" (str "step-" index))])]])


(defn view
  "Welcome page for new users with step-by-step instructions on how to get started"
  [tr]
  (let [create-app? (<sub [::create-v2/start-create?])]
    [:section.mx-auto.max-w-6xl.rounded
     [:div.flex.justify-center
      [:div.flex.flex-col
       [text-blocks tr create-app?]
       [:div.mx-8.md:mx-20.my-20.grid.sm:grid-cols-2.md:grid-cols-3.lg:grid-cols-5
        (futil/for-frag [step-index (map inc (range 5))]
          [step-card tr step-index])]
       [create-application-button tr "mb-20" create-app?]
       (when create-app?
         [create-v2/create-preliminary-selections tr])]]]))
